import { Box, Typography, Button } from '@mui/material';

interface ErrorPanelProps {
  error?: Error | null;
  onRetry?: () => void;
}

export function ErrorPanel({ error, onRetry }: ErrorPanelProps) {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h5" color="error" gutterBottom>
        Something went wrong
      </Typography>
      {error && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {error.message}
        </Typography>
      )}
      {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          Retry
        </Button>
      )}
    </Box>
  );
}
